<div class="reports__cards pb-15">
  <div *ngFor="let card of summaryCards;" class="reports__cardsItem" [ngClass]="card.colorClass">
    <div class="item__body">
      <div class="item__info">
        <h2 class="title">{{ card.label }}</h2>
        <p class="description">{{ card.sublabel }}</p>
      </div>
      <div class="item__values">
        <span class="count">{{ card.count }}</span>
        <span class="amount">{{ card.amount }}</span>
      </div>
      
      <div class="item__arrow">
        <i [class]="card.arrowIcon"></i>
      </div>
    </div>
  </div>
</div>